import {getLanguage, t} from 'react-switch-lang';
import {format} from 'date-fns';
import React from 'react';
import {Tooltip} from 'antd';

const lang = getLanguage();

export const QUARTER = {
  I: 'I',
  II: 'II',
  III: 'III',
  IV: 'IV',
};

export const REVISION_MODE = {
  REGULAR: 'REGULAR',
  EXTRAORDINARY: 'EXTRAORDINARY',
  REGULAR_MNE: 'REDOVNA',
  EXTRAORDINARY_MNE: 'VANREDNA',
};

export const RISK_LEVEL = {
  LOW: {mne: 'Nizak', en: 'Low', value: 'LOW'},
  MEDIUM: {mne: 'Srednji', en: 'Medium', value: 'MEDIUM'},
  HIGH: {mne: 'Visok', en: 'High', value: 'HIGH'},
  NOT_DEFINED: {mne: 'Nije definisano', en: "Not defined", value: 'NOT_DEFINED'},
  MODERATE: {mne: 'Umjeren', en: "Moderate", value: 'MODERATE'},
  VERY_HIGH: {mne: 'Veoma visok', en: "Very high", value: 'VERY_HIGH'},
};

export const FINDING_STATUS = {
  COMPLETED: {mne: 'Realizovano', en: 'Completed', value: 'COMPLETED'},
  INCOMPLETE: {mne: 'Nerealizovano', en: 'Incomplete', value: 'INCOMPLETE'},
  PARTIALLY_COMPLETED: {
    mne: 'Djelimično realizovano',
    en: 'Partially completed',
    value: 'PARTIALLY_COMPLETED',
  },
  NOT_STARTED:{mne: 'Nerealizovano', en: 'Incomplete', value: 'NOT_STARTED'},
  CONTINUOUS: {mne: 'Kontinuirano', en: 'Continous', value: 'CONTINUOUS'},
  IN_PROGRESS: {mne: 'U toku', en: 'In progress', value: 'IN_PROGRESS'},
  ABORTED: {mne: 'Otkazano', en: 'Aborted', value: 'ABORTED'},
};
export const PROGRESS_PERCENTAGE = {
  ZERO: { label: '0%', value: 0},
  TEN: { label: '10%', value: 10},
  TWENTY: { label: '20%', value: 20},
  THIRTY: { label: '30%', value: 30},
  FORTY: { label: '40%', value: 40},
  FIFTY: { label: '50%', value: 50},
  SIXTY: { label: '60%', value: 60},
  SEVENTY: { label: '70%', value: 70},
  EIGHTY: { label: '80%', value: 80},
  NINETY: { label: '90%', value: 90},
  HUNDRED: { label: '100%', value: 100},
}
export const PROGRESS_STATUS = {
  SATISFACTORY: {mne: 'Adekvatno', en: 'Satisfactory', value: 'SATISFACTORY'},
  MODERATE: {mne: 'Umjeren', en: 'Moderate', value: 'MODERATE'},
  CRITICAL: {mne: 'Kritično', en: 'Critical', value: 'CRITICAL'},

}
export const getRevisionTableColumns = (history, onDelete, allowCRUD) => [
  {
    key: 'referenceNumber',
    dataIndex: 'referenceNumber',
    title: t('revisions.referenceNumber'),
    sorter: true,
  },
  {
    key: 'name',
    dataIndex: 'name',
    title: t('revisions.revisionName'),
    sorter: true,
    render: (data) => {
      return  data ? data : '/';
    },
  },
  {
    key: 'revisionType',
    dataIndex: 'revisionType',
    title: t('revisions.revisionType'),
    render: (data) => {
      return <>{lang === 'mne' ? data?.name : data?.nameEn}</>;
    },
    sorter: true,
  },
  {
    key: 'revisionScopes',
    dataIndex: 'revisionScopes',
    title: t('revisions.area'),
    render: (data) => {
      const revisionScopesData = data
        .map((r) => (lang === 'mne' ? r?.name : r?.nameEn))
        .filter(Boolean)
        .join(', ')
      return (
        <Tooltip placement="topLeft" title={revisionScopesData}>
          <div
            style={{
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}>
            {revisionScopesData}
          </div>
        </Tooltip>
      );
    },
    sorter: true,
  },
  {
    key: 'revisionMode',
    dataIndex: 'revisionMode',
    title: t('revisions.types'),
    render: (data) => {
      return (
        <>
          {data === REVISION_MODE.REGULAR
            ? t('revisionMode.regular')
            : t('revisionMode.extraordinary')}
        </>
      );
    },
    sorter: true,
  },
  {
    key: 'issuedAt',
    dataIndex: 'issuedAt',
    title: t('revisions.dateOfIssue'),
    render: (data) => format(new Date(data ? data : null), 'dd.MM.yyyy'),
    sorter: true,
  },
  {
    key: 'quarter',
    dataIndex: 'quarter',
    title: t('revisions.quarter'),
    sorter: true,
  },

  {
    key: 'status',
    dataIndex: 'status',
    title: '',
    render: (record, item) => {
      if (allowCRUD)
        return (
          <div style={{display: 'flex', gap: '20px'}}>
            <Tooltip title={t('common.edit')}>
              <img
                onClick={(e) => {
                  e.stopPropagation();
                  history.push({
                    pathname: `/revisions/${item?.id}`,
                    state: {isEditing: true},
                  });
                }}
                style={{cursor: 'pointer'}}
                src={process.env.PUBLIC_URL + '/images/blueEdit.svg'}
              />
            </Tooltip>
            <Tooltip title={t('common.delete')}>
              <img
                onClick={async (e) => {
                  e.stopPropagation();
                  await onDelete(item);
                }}
                style={{cursor: 'pointer'}}
                src={process.env.PUBLIC_URL + '/images/delete.svg'}
              />
            </Tooltip>
          </div>
        );
    },
  },
];

export const getRevisionSubTableColumns = (
  history,
  onDelete,
  allowCRUD = true,
  isSortable = true,
  allowEdit = true
) => [
  {
    key: 'name',
    dataIndex: 'name',
    title: t('revisions.findingName'),
    sorter: isSortable,
  },
  {
    key: 'findingStatus',
    dataIndex: 'findingStatus',
    title: t('revisions.findingStatus'),
    render: (dataIndex) => (
      <span
        style={
          dataIndex === FINDING_STATUS.COMPLETED.value
            ? {color: '#37C35C', fontWeight: 'bold'}
            : dataIndex === FINDING_STATUS.INCOMPLETE.value
            ? {color: '#F59A1F', fontWeight: 'bold'}
            : dataIndex === FINDING_STATUS.PARTIALLY_COMPLETED.value
            ? {color: '#DFA558', fontWeight: 'bold'}
            : dataIndex === FINDING_STATUS.CONTINUOUS.value
            ? {color: '#df7858', fontWeight: 'bold'}
            : dataIndex === FINDING_STATUS.IN_PROGRESS.value
            ? {color: '#df8558', fontWeight: 'bold'}
            : {color: '#F5501F', fontWeight: 'bold'}
        }
      >
        {dataIndex
          ? dataIndex === FINDING_STATUS.INCOMPLETE.value
            ? t('findingStatus.incomplete')
            : dataIndex === FINDING_STATUS.COMPLETED.value
            ? t('findingStatus.completed')
            : dataIndex === FINDING_STATUS.PARTIALLY_COMPLETED.value
            ? t('findingStatus.partiallyComplete')
            : dataIndex === FINDING_STATUS.CONTINUOUS.value
            ? t('findingStatus.continuous')
            : dataIndex === FINDING_STATUS.IN_PROGRESS.value
            ? t('findingStatus.inProgress')
            : t('findingStatus.aborted')
          : t('findingStatus.incomplete')}
      </span>
    ),
    sorter: isSortable,
  },
  {
    key: 'departments',
    dataIndex: 'departments',
    title: t('departments.department'),
    sorter: isSortable,
    width: 200,
    render: (record) => (
      <Tooltip title={lang === 'mne' ? (record?.map(r=>r?.name).join(', ')) : ( record?.map(r=>r?.nameEn).join(', '))}>
        <div> {lang === 'mne' ? (record?.map(r=>r?.name).join(', ')) : ( record?.map(r=>r?.nameEn).join(', '))}</div>
      </Tooltip>
    ),
  },
  {
    key: 'responsiblePerson',
    dataIndex: 'responsiblePerson',
    title: t('departments.responsibleUsers'),
    width: 150,
    sorter: isSortable,
    render: (record) => (
      <Tooltip title={record?.fullName}>
        <div>{record?.fullName}</div>
      </Tooltip>
    ),
  },

  {
    key: 'auditor',
    dataIndex: 'auditor',
    title: t('revisions.auditor'),
    width: 230,
    sorter: isSortable,
    render: (record) => (
      <Tooltip title={record?.fullName}>
        <div>{record?.fullName}</div>
      </Tooltip>
    ),
  },
  {
    key: 'revisionScope',
    dataIndex: 'revisionScope',
    title: t('revisions.area'),
    render: (data) => data ? lang === 'mne' ? data?.name : data?.nameEn : '/',
    sorter: isSortable,
  },
  {
    key: 'initialDeadline',
    dataIndex: 'initialDeadline',
    title: t('revisions.dateOfRealisation'),
    render: (data) => format(new Date(data ? data : null), 'dd.MM.yyyy'),
    sorter: isSortable,
  },
  {
    key: 'riskLevel',
    dataIndex: 'riskLevel',
    title: t('revisions.riskLevel'),
    render: (dataIndex) => (
      <span
        style={
          dataIndex === RISK_LEVEL.LOW.value
            ? {color: '#37C35C', fontWeight: 'bold'}
            : dataIndex === RISK_LEVEL.MEDIUM.value
            ? {color: '#F59A1F', fontWeight: 'bold'}
            : dataIndex === RISK_LEVEL.NOT_DEFINED.value
            ? {color: '#97a3b4', fontWeight: 'bold'}
            : dataIndex === RISK_LEVEL.MODERATE.value
            ? {color: '#DFA558', fontWeight: 'bold'}
            : dataIndex === RISK_LEVEL.HIGH.value
            ? {color: '#FFBF00', fontWeight: 'bold'}
            : {color: '#F5501F', fontWeight: 'bold'}
        }
      >
        {dataIndex === RISK_LEVEL.LOW.value
          ? t('riskLevel.low')
          : dataIndex === RISK_LEVEL.MEDIUM.value
          ? t('riskLevel.medium')
          : dataIndex === RISK_LEVEL.NOT_DEFINED.value
          ? t('riskLevel.notDefined')
          : dataIndex === RISK_LEVEL.MODERATE.value
          ? t('riskLevel.moderate')
          : dataIndex === RISK_LEVEL.HIGH.value
          ? t('riskLevel.high')
          : t('riskLevel.veryHigh')}
      </span>
    ),
    sorter: isSortable,
  },
  {
    key: 'progressStatus',
    dataIndex: 'progressStatus',
    title: t('revisions.progressStatus'),
    render: (dataIndex) => (
      <span
        style={
          dataIndex === PROGRESS_STATUS.SATISFACTORY.value
            ? {color: '#37C35C', fontWeight: 'bold'}
            : dataIndex === PROGRESS_STATUS.MODERATE.value
              ? {color: '#F59A1F', fontWeight: 'bold'}
              : {color: '#F5501F', fontWeight: 'bold'}
        }
      >
        {dataIndex
          ? dataIndex === PROGRESS_STATUS.SATISFACTORY.value
            ? t('progressStatus.satisfactory')
            : dataIndex === PROGRESS_STATUS.MODERATE.value
              ? t('progressStatus.moderate')
              : t('progressStatus.critical')
          : null
        }
      </span>
    ),
    sorter: isSortable,
  },
  {
    key: 'status',
    dataIndex: 'status',
    title: '',
    render: (record, item) => {
        return (
            (((item?.findingStatus === 'ABORTED') || (item?.findingStatus === 'COMPLETED')) ? allowEdit : allowCRUD) &&
            <div style={{display: 'flex', gap: '10px', justifyContent: "end", paddingRight: '10px'}}>
              <Tooltip title={t('common.edit')}>
                <img
                  onClick={(e) => {
                    e.stopPropagation();

                    history.push({
                      pathname: `/revisions/${item?.revision?.id}/findings/${item?.id}`,
                      state: {isEditing: true},
                    });
                  }}
                  style={{cursor: 'pointer'}}
                  src={process.env.PUBLIC_URL + '/images/blueEdit.svg'}
                />
              </Tooltip>
            <Tooltip title={t('common.delete')}>
              <img
                onClick={async (e) => {
                  e.stopPropagation();
                  await onDelete(item);
                }}
                style={{cursor: 'pointer'}}
                src={process.env.PUBLIC_URL + '/images/delete.svg'}
              />
            </Tooltip>
          </div>
        );
    },
  },
];

export const getRevisionTableColumnsDashboard = (
  history,
  onDelete,
  isSortable = false,
  allowCRUD = false,
  allowEdit = false
) => [
  {
    key: 'revision',
    dataIndex: 'revision',
    title: t('revisions.referenceNumber'),
    render: (data) => {
      return data?.referenceNumber;
    },
  },
  {
    key: 'name',
    dataIndex: 'name',
    title: t('revisions.findingName'),
    sorter: isSortable,
  },
  {
    key: 'revision',
    dataIndex: 'revision',
    title: t('revisions.revisionType'),
    render: (data) => {
      return (
        <>
          {lang === 'mne'
            ? data?.revisionType?.name
            : data?.revisionType?.nameEn}
        </>
      );
    },
  },
  {
    key: 'id',
    dataIndex: 'id',
    title: t('revisions.findingId'),
  },
  {
    key: 'riskLevel',
    dataIndex: 'riskLevel',
    title: t('revisions.riskLevel'),
    render: (dataIndex) => (
      <span
        style={
          dataIndex === RISK_LEVEL.LOW.value
            ? {color: '#37C35C', fontWeight: 'bold'}
            : dataIndex === RISK_LEVEL.MEDIUM.value
              ? {color: '#F59A1F', fontWeight: 'bold'}
              : dataIndex === RISK_LEVEL.NOT_DEFINED.value
                ? {color: '#97a3b4', fontWeight: 'bold'}
                : dataIndex === RISK_LEVEL.MODERATE.value
                  ? {color: '#DFA558', fontWeight: 'bold'}
                  : dataIndex === RISK_LEVEL.HIGH.value
                    ? {color: '#FFBF00', fontWeight: 'bold'}
                    : {color: '#F5501F', fontWeight: 'bold'}
        }
      >
        {dataIndex === RISK_LEVEL.LOW.value
          ? t('riskLevel.low')
          : dataIndex === RISK_LEVEL.MEDIUM.value
          ? t('riskLevel.medium')
          : dataIndex === RISK_LEVEL.NOT_DEFINED.value
          ? t('riskLevel.notDefined')
          : dataIndex === RISK_LEVEL.MODERATE.value
          ? t('riskLevel.moderate')
          : dataIndex === RISK_LEVEL.HIGH.value
          ? t('riskLevel.high')
          : t('riskLevel.veryHigh')}
      </span>
    ),
    sorter: isSortable,
  },
  {
    key: 'progressStatus',
    dataIndex: 'progressStatus',
    title: t('revisions.progressStatus'),
    render: (dataIndex) => (
      <span
        style={
          dataIndex === PROGRESS_STATUS.SATISFACTORY.value
            ? {color: '#37C35C', fontWeight: 'bold'}
            : dataIndex === PROGRESS_STATUS.MODERATE.value
              ? {color: '#F59A1F', fontWeight: 'bold'}
              : {color: '#F5501F', fontWeight: 'bold'}
        }
      >
        {dataIndex
          ? dataIndex === PROGRESS_STATUS.SATISFACTORY.value
            ? t('progressStatus.satisfactory')
            : dataIndex === PROGRESS_STATUS.MODERATE.value
              ? t('progressStatus.moderate')
              : t('progressStatus.critical')
          : null
        }
      </span>
    ),
    sorter: isSortable,
  },
  {
    key: 'status',
    dataIndex: 'status',
    title: '',
    render: (record, item) => {
        return (
          (((item?.findingStatus === 'ABORTED') || (item?.findingStatus === 'COMPLETED')) ? allowEdit : allowCRUD) &&
          <div style={{display: 'flex', gap: '20px'}}>
              <Tooltip title={t('common.edit')}>
              <img
                onClick={(e) => {
                  e.stopPropagation();

                  history.push({
                    pathname: `/revisions/${item?.revision?.id}/findings/${item?.id}`,
                    state: {isEditing: true},
                  });
                }}
                style={{cursor: 'pointer'}}
                src={process.env.PUBLIC_URL + '/images/blueEdit.svg'}
              />
            </Tooltip>
            <Tooltip title={t('common.delete')}>
              <img
                onClick={async (e) => {
                  e.stopPropagation();
                  await onDelete(item);
                }}
                style={{cursor: 'pointer'}}
                src={process.env.PUBLIC_URL + '/images/delete.svg'}
              />
            </Tooltip>
          </div>
        );
    },
  },
];
export const revisionsFilter = (data) => {
  const parameters = [];

  if (data.issuedAtFrom) {
    parameters.push(
      `issuedAt.greaterThanOrEqual=${
        format(new Date(data?.issuedAtFrom), 'yyyy-MM-dd') +
        'T' +
        format(new Date(data?.issuedAtFrom), 'hh:mm:ss')
      }`
    );
  }
  if (data?.issuedAtTo) {
    parameters.push(
      `issuedAt.lessThanOrEqual=${
        format(new Date(data?.issuedAtTo), 'yyyy-MM-dd') +
        'T' +
        format(new Date(data?.issuedAtTo), 'hh:mm:ss')
      }`
    );
  }
  if (data?.searchInput !== '') {
    parameters.push(`referenceNumber.contains=${data?.searchInput}`);
  }

  if (data?.revisionScopes) {
    for (let i = 0; i < data?.revisionScopes?.length; i++) {
      parameters.push(`revisionScopeId.in=${data?.revisionScopes[i].value}`);
    }
  }

  if (data?.revisionType) {
    for (let i = 0; i < data?.revisionType?.length; i++) {
      parameters.push(`revisionTypeId.in=${data?.revisionType[i]?.value}`);
    }
  }

  if (data?.quarter) {
    for (let i = 0; i < data?.quarter?.length; i++) {
      parameters.push(`quarter.in=${data?.quarter[i]?.value}`);
    }
  }

  if (data?.revisionMode) {
    parameters.push(`revisionMode.equals=${data?.revisionMode?.value}`);
  }
  /*TODO FIX THIS*/
  /*if(data?.department){
        for (let i = 0; i <data?.department?.length ; i++) {
            parameters.push(
                `departmentId.in=${
                    data?.department[i]?.value
                }`
            );
        }

    }*/

  return parameters.join('&');
};

export const findingsFilter = (data) => {
  const parameters = [];
  if (data.issuedAtFrom) {
    parameters.push(
      `completedAt.greaterThanOrEqual=${
        format((data?.issuedAtFrom), "yyyy-MM-dd'T'HH:mm:ss'Z'")
      }`
    );
  }
  if (data?.issuedAtTo) {
    parameters.push(
      `completedAt.lessThanOrEqual=${
        format(new Date(data?.issuedAtTo), "yyyy-MM-dd'T'HH:mm:ss'Z'")
      }`
    );
  }
  if (data?.searchInput !== '') {
    parameters.push(`name.contains=${data?.searchInput}`);
  }
  if (data?.riskLevel) {
    parameters.push(`riskLevel.equals=${data?.riskLevel?.value}`);
  }
  if (data?.findingStatus) {
    parameters.push(`findingStatus.equals=${data?.findingStatus?.value}`);
  }

  if (data?.department) {
    for (let i = 0; i < data?.department?.length; i++) {
      parameters.push(`departmentId.in=${data?.department[i]?.value}`);
    }
  }

  return parameters.join('&');
};
